import { ref } from '@vue/composition-api'
import store from '@/store'
import { getValidationErrors } from '@core/comp-functions/forms/form-error'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'

export default function useWorkplaceDueDateRulesSave(refetchData, onSaveSuccess) {
  const toast = useToast()
  const loading = ref(false)

  function showValidationToast(text) {
    toast({
      component: ToastificationContent,
      position: 'top-right',
      props: {
        title: 'Validação',
        icon: 'AlertCircleIcon',
        variant: 'warning',
        text,
      },
    })
  }

  function saveDueDateRules(formRef) {
    const validationError = formRef.validateDueDateRulesBeforeSave()
    if (validationError) {
      showValidationToast(validationError)
      return
    }

    loading.value = true
    const payload = formRef.getPayload()

    store.dispatch('app-institution/dueDateRules', payload)
      .then(() => {
        refetchData()
        if (onSaveSuccess) {
          onSaveSuccess()
        }
        loading.value = false
      })
      .catch(error => {
        loading.value = false
        const errors = getValidationErrors(error)
        if (errors) {
          toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Erro',
              icon: 'XOctagonIcon',
              variant: 'danger',
              text: errors,
            },
          })
        }
      })
  }

  function saveDueDateRulesCallback(formRef, saveCallback) {
    const validationError = formRef.validateDueDateRulesBeforeSave()
    if (validationError) {
      showValidationToast(validationError)
      return Promise.reject(new Error(validationError))
    }

    loading.value = true
    const payload = formRef.getPayload()

    return saveCallback(payload)
      .then(() => {
        refetchData()
        if (onSaveSuccess) {
          onSaveSuccess()
        }
        loading.value = false
      })
      .catch(error => {
        loading.value = false
        const errors = getValidationErrors(error)
        if (errors) {
          toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Erro',
              icon: 'XOctagonIcon',
              variant: 'danger',
              text: errors,
            },
          })
        }
        return Promise.reject(error)
      })
  }

  return {
    loading,
    saveDueDateRules,
    showValidationToast,
    saveDueDateRulesCallback,
  }
}
